import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class AAAGameActionDropDownContainer extends React.Component {
  render() {
    const { AAAGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          AAAGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={AAAGameActionStore.clearClippyCache}
        clearStatsApiCache={AAAGameActionStore.clearStatsApiCache}
        resendGame={AAAGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(AAAGameActionDropDownContainer));
